import { render } from "./SelectListDependencyItem.vue?vue&type=template&id=068cc9c0"
import script from "./SelectListDependencyItem.vue?vue&type=script&lang=js"
export * from "./SelectListDependencyItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__